import { useContext } from "react";
import WarningModal from "../WarningModal";
import { ToolContext } from "../../context/ToolContext";
import Feature from "../feature-flag/Feature";

const CommittedLoadPresentMessage = () => {
  const { toolState, setToolState } = useContext(ToolContext);

  return (
    <Feature flag="UseAcceptToConnectDataEnabled">
      {toolState.showCommittedLoadMessage && (
        <WarningModal
          action={() => setToolState({ showCommittedLoadMessage: false })}
          msg={"Committed load is present on this substation"}
          hideYesButton={true}
          dismissLabel="OK"
        />
      )}
    </Feature>
  );
};

export default CommittedLoadPresentMessage;
